import groupBy from 'lodash/groupBy';
import MessageDefinition from '../messages/message-definitions.json';
import getMessage from './getMessage';

const UNKNOWN_MESSAGE_TYPE = 'danger';

/**
 * Compõe uma mensagem agrupada.
 * @param {String} type Tipo do grupo que será criado.
 * @param {Object[]} errorsGroup Coleção de erros de validação do grupo.
 * @param {Object} messageParams Parâmetros das mensagens.
 * @returns {{ messageList }} Objeto de mensagem resultando, acrescido de lista da lista mensagens
 * de validação.
 */
function composeGroupedMessage(type, errorsGroup, messageParams) {
  if (errorsGroup.length === 1) {
    return { ...getMessage(errorsGroup[0], messageParams) };
  }
  const messageList = errorsGroup.map(error => getMessage(error, messageParams));
  return {
    type,
    messageList,
  };
}

function hasMessageType(errorItem) {
  return MessageDefinition[errorItem.messageCode]
    && MessageDefinition[errorItem.messageCode].type;
}


/**
 * Retorna o tipo da mensagem do erro.
 * @param {Object} errorItem Item de erro das validações.
 * @returns {String} Tipo da mensagem, como danger, info, warning e etc..
 */
function getMessageType(errorItem) {
  if (hasMessageType(errorItem)) {
    return MessageDefinition[errorItem.messageCode].type;
  }
  return UNKNOWN_MESSAGE_TYPE;
}

/**
 * Testa se um erro possui informações de validação de dados.
 * @param {*} mainErrorData Dados do erro principal.
 * @returns {Boolean}
 */
export function isValidationError(mainErrorData) {
  return Array.isArray(mainErrorData.validationErrors)
    && mainErrorData.validationErrors.length > 0;
}

function getGroupByTypes(mainErrorData) {
  if (hasMessageType(mainErrorData)) {
    return {
      [getMessageType(mainErrorData)]: mainErrorData.validationErrors,
    };
  }
  return groupBy(mainErrorData.validationErrors, getMessageType);
}

/**
 * Agrupa os erros de validação em mensagens compostas separadas em grupos por tipo, como
 * danger, warning, info e etc., porém se a mensagem principal possuir um tipo, todas as filhas
 * ficarão juntas.
 * @param {*} mainErrorData Dados do erro principal.
 * @param {*} [messageParams] Parametros para mensagens.
 * @returns {[]} Array de mensagens de validação.
 */
export function getValidationErrors(mainErrorData, messageParams) {
  const typeGroups = getGroupByTypes(mainErrorData);
  return Object.keys(typeGroups).map(type => composeGroupedMessage(
    type,
    typeGroups[type],
    messageParams,
  ));
}
